import * as React from 'react';
import { IStaticPageWrapperProps, StaticPageWrapper, centeredMessageStyle } from 'components/static-pages/StaticPageWrapper';

export const MyCoachingPage = (props:IStaticPageWrapperProps) => {
	const url = `https://pickatime.com/client?ven=11613939&event=331130&retimp&adminLogin=on&user_key=707890d1-1fc2-4bd0-ac27-1db742d5439b`;	

	return (	
		<StaticPageWrapper
			backgroundImage="/res_sys/my_coaching_splash.jpg" 
      backgroundRepeat="initial"
      backgroundPosition="initial"
      backgroundSize="cover" 
			{...props}
		>
			<div style={centeredMessageStyle}>
				<div style={{textAlign:'center',fontFamily:'Open Sans',fontWeight:600,fontSize:'32px',color:'#263692', paddingTop:'20px', paddingBottom:'25px',lineHeight: '32px'}}>My Coaching</div>
				<div style={{textAlign:'center', marginTop:'0px', marginBottom:'25px'}}>
					<a target="_blank" href={url} className="go_button" style={{borderRadius:'20px',padding: '0 20px', boxShadow: '2px 2px 4px 0px rgba(0,0,0,0.5)', fontFamily:'Roboto'}}>Schedule Now</a>
				</div>
				<div style={{fontSize:'18px',fontFamily:'Open Sans', fontWeight:400, fontStyle:'italic',color:'#4A4A4A', textAlign:'center',paddingBottom:'8px'}}>
					…and be on your way to improved health.<br/><br/>
				</div>
			</div>
		</StaticPageWrapper>
	);
};

